import React from 'react';
import { useNavigate } from 'react-router-dom';
import GenericEntityList from '../../components/Common/GenericEntityList';

const TradeManagement: React.FC = () => {
  const navigate = useNavigate();

  const handleCreateTrade = () => {
    navigate('/trades/create');
  };

  return (
    <GenericEntityList
      entityType="trade"
      detailsRoute="/trades"
      onCreateClick={handleCreateTrade}
      createButtonLabel="Add Trade"
      showCreateButton={true}
      showExportButton={true}
    />
  );
};

export default TradeManagement;

